import { useState, useEffect, useCallback } from 'react'

import httpClient from '../httpClient'
import { apiErrorMessage } from '../lib/utils'

const useOrders = () => {
  const [loadingOrders, setLoadingOrders] = useState(true);
  const [updatingOrder, setUpdatingOrder] = useState(false);
  const [loadState, setLoadState] = useState(true)
  const [error, setApiError] = useState(null);
  const [orders, setOrders] = useState(null);
  const [metadata, setMetadata] = useState(null);
  const [order, setOrder] = useState(null);

  const fetchOrders = useCallback(async () => {
    try {
      setLoadingOrders(true);
      setApiError(null);
      const { data, meta } = await httpClient('lab_orders');
      setOrders(data);
      setMetadata(meta);
    } catch (err) {
      setApiError(apiErrorMessage(err));
    } finally {
      setLoadingOrders(false);
    }
  }, []);

  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);

  const searchOrders = useCallback(async (query) => {
    try {
      setLoadingOrders(true);
      setApiError(null)
      const { data, meta } = await httpClient(`lab_orders/search?${query}`)
      setOrders(data)
      setMetadata(meta)
      setLoading(false)
    } catch (err) {
      setApiError(apiErrorMessage(err))
      setLoading(false)
    }
  }, [])

  const getOrder = useCallback(async (id) => {
    setLoadState(true)
    try {
      const data = await httpClient(`lab_orders/${id}`);
      setOrder(data);
      setLoadState(false)
    } catch (err) {
      setApiError(apiErrorMessage(err));
    }
  }, []);

  const updateOrder = useCallback(async (id, type, value) => {
    setUpdatingOrder(true);
    try {
      const response = await httpClient.patch(`lab_orders/${id}`, { type, value });
      setOrder(response);

      setOrders((prev) =>
        prev
          ? prev.map((o) =>
            o.attributes.guid === id ? response.data : o
          )
          : prev
      );
    } catch (err) {
      setApiError(apiErrorMessage(err));
    } finally {
      setUpdatingOrder(false);
    }
  }, []);

  const refundOrder = useCallback(async (id, refundAmount, refundNote) => {
    // setUpdatingOrder(true);
    try {
      const response = await httpClient.post(
        `lab_orders/${id}/refund`,
        {
          refund_amount: refundAmount,
          refund_note: refundNote,
        }
      );
      setOrder(response)
      // setLoading(false)
    } catch (err) {
      setApiError(apiErrorMessage(error))
    } finally {
      // setUpdatingOrder(false)
    }
  })

  const updateLineItemStatus = async (e, selectedLineItems, labOrderId) => {
    // setUpdatingOrder(true);
    try {
      const response = await httpClient.patch(
        `/lab_orders/${labOrderId}/line_items/update_multiple_line_item_status`,
        {
          ids: [...selectedLineItems],
          value: e.target.value
        }
      );
      setOrder(response);

      setOrders((prev) =>
        prev
          ? prev.map((o) =>
            o.attributes.guid === labOrderId ? response.data : o
          )
          : prev
      );

    } catch (err) {
      setApiError(apiErrorMessage(error))
    }

  };

  const updateLineItem = async (type, value, labOrderId, lineItemGuid) => {
    // setUpdatingOrder(true);
    try {
      const response = await httpClient.patch(
        `/lab_orders/${labOrderId}/line_items/${lineItemGuid}`,
        { type, value }
      );
      setOrder(response);

      setOrders((prev) =>
        prev
          ? prev.map((o) =>
            o.attributes.guid === labOrderId ? response.data : o
          )
          : prev
      );

    } catch (error) {
      setApiError(apiErrorMessage(error))
    } finally {
      // setUpdatingOrder(false)
    }
  };

  return {
    orders,
    error,
    loading: loadingOrders,
    updating: updatingOrder,
    refetchOrders: fetchOrders,
    getOrder,
    order,
    metadata,
    searchOrders,
    updateOrder,
    refundOrder,
    updateLineItemStatus,
    updateLineItem,
    loadState
  }
}

export default useOrders
